"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function CloseSquareTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'close-square',
        theme: 'twotone',
        nameWithTheme: 'close-square-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: primaryColor,
                    d: 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M184 840h656V184H184v656zm163.9-473.9c-4.4-5.2-.7-13.1 6.1-13.1h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: primaryColor,
                    d: 'M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9c-4.4 5.2-.7 13.1 6.1 13.1z'
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'close-square-twotone';
var CloseSquareTwoTone = temp;
exports.default = CloseSquareTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.3@@ant-design/icons/lib/twotone/CloseSquareTwoTone.js
// module id = 1063
// module chunks = 0 1